import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { AppletEditionPricingContainerModel } from "../../../../../models/aggregates/applet/applet-edition-pricings-container.model";
import { BaseApiTemplateService, Core2Config, ApiVisa, Pagination, ApiResponseModel } from "../shared";
import { Observable } from "rxjs";

@Injectable({
    providedIn: 'root',
})
export class AppletEditionPricingService extends BaseApiTemplateService<AppletEditionPricingContainerModel>{
    constructor(http: HttpClient){
        super();
        this.apiUrl = Core2Config.DOMAIN_URL + Core2Config.PLATFORM_DOMAIN_URL_PREFIX + Core2Config.APPLET_PREFIX + 'applet-edition-pricings';
        this.endpoint_path = Core2Config.PLATFORM_DOMAIN_URL_PREFIX + Core2Config.APPLET_PREFIX + 'applet-edition-pricings';
        this.httpClient = http;
    }

    private setUrl(endpoint: string, apiVisa: ApiVisa) {
        this.apiUrl = apiVisa.api_domain_url + Core2Config.PLATFORM_DOMAIN_URL_PREFIX + Core2Config.APPLET_PREFIX  + `applet-edition-pricings/${endpoint}`;
        this.endpoint_path = Core2Config.PLATFORM_DOMAIN_URL_PREFIX + Core2Config.APPLET_PREFIX + `applet-edition-pricings/${endpoint}`
    }
    
    getAsSysadmin(apiVisa: ApiVisa) {
        this.setUrl('sysadmin-ep', apiVisa);
        return super.get(apiVisa);
    }

    getByGuidAsSysadmin(guid: string, apiVisa: ApiVisa){
        this.setUrl('sysadmin-ep', apiVisa);
        return super.getByGuid(guid, apiVisa);
      }

    postAsSysadmin(dtoObject: AppletEditionPricingContainerModel, apiVisa: ApiVisa) {
        this.setUrl('sysadmin-ep', apiVisa);
        return super.post(dtoObject, apiVisa);
    }

    putAsSysadmin(dtoObject: AppletEditionPricingContainerModel, apiVisa: ApiVisa) {
        this.setUrl('sysadmin-ep', apiVisa);
        return super.put(dtoObject, apiVisa);
    }

    deleteAsSysadmin(guid: string, apiVisa: ApiVisa) {
        this.setUrl('sysadmin-ep', apiVisa);
        return super.delete(guid, apiVisa);
    }

    getByCriteriaAsSysadmin(pagination: Pagination, apiVisa: ApiVisa) {
        this.setUrl('sysadmin-ep', apiVisa);
        return super.getByCriteria(pagination, apiVisa);
    }



    getAsTenantAdmin(
        tenantCode: string,
        visa: ApiVisa
    ): Observable<ApiResponseModel<any>> {
        let url = this.apiUrl + '/tenant-admin-ep' + '/' + tenantCode;
        if (this.endpoint_path && visa.api_domain_url) {
            url = visa.api_domain_url + this.endpoint_path + '/tenant-admin-ep' + '/' + tenantCode;
        }
        return this.httpClient.get<ApiResponseModel<any>>(
            url,
            this.getHttpHeader(visa)
        );
    }

}